module.exports = "//cdn-deploy.cdn.bcebos.com/muses_plt/static/img/4.6-flow.07d0d5b6.png";